import React, { useState } from "react";
import { stringDataCheck } from "../../../utils/helpers/dataHelper";

export default function Body({ profile, loadingStatus }) {
  const [loading, setLoading] = useState(false);
  console.log("profile  ", profile);
  console.log("loadingStatus  ", loadingStatus);
  return (
    <div className="profile_card">
      <div>
        <p className="profile_card_header">Full Name</p>
        <p className="profile_card_content_top">
          {stringDataCheck(profile["fullName"], 3)}
        </p>
      </div>
      <div>
        <p className="profile_card_header"> Matric Number:</p>
        <p className="profile_card_content_bottom">
          {stringDataCheck(profile["matricNumber"], 1)}
        </p>
      </div>
      <div>
        <p className="profile_card_header"> Program:</p>
        <p className="profile_card_content_bottom">
          {stringDataCheck(profile["program"], 1)}
          {/* Set of {stringDataCheck(profile["programYear"], 1)} */}
        </p>
      </div>
      <div className="flex mb-4">
        <div className="w-1/2">
          <p className="profile_card_header">set Name</p>
          <p className="profile_card_content_bottom">
            {stringDataCheck(profile["setName"], 1)}
          </p>
        </div>
        <div className="w-1/2">
          <p className="profile_card_header">Class of</p>
          <p className="profile_card_content_bottom">
            {stringDataCheck(profile["graduationYear"], 1)}
          </p>
        </div>
      </div>
    </div>
  );
}
